import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'src/common/components/base-button';
import { transactionSearchModalStyles } from '../transaction-based-return-styles';
import { ReturnPolicyResponse } from '../interfaces/get-effective-return-policy-response';
import {
  getDateRangeInterval,
  isReceiptLookupPeriodGreaterThanAMonth,
  isReceiptLookupPeriodGreaterThanAWeek,
} from '../transaction-search-helper/date-range-helper';

interface ISearchResultScreenHead {
  effectivePolicy?: ReturnPolicyResponse;
  setDateRange: Function;
  listCount: number;
  subHeadingText: string;
}

export enum DateRanges {
  'yesterday',
  'lastWeek',
  'lastMonth',
}

export const SearchResultsScreenHead = (props: ISearchResultScreenHead): JSX.Element => {
  const classes = transactionSearchModalStyles();
  const { effectivePolicy, listCount, setDateRange, subHeadingText } = props;
  const { t } = useTranslation();

  const handleSetDateRange = (rangeType: DateRanges) => {
    setDateRange(getDateRangeInterval(rangeType));
  };

  return (
    <>
      <Grid container direction='column' justifyContent='center' className={`fullWidth`}>
        <Grid item className={classes.fitHeight}>
          <Grid container direction='column' className={`fullWidth`}>
            <Typography
              className={`${classes.returnItemTitleHeader} ${classes.codeContainerSubHeaderLabel}`}
              data-testid='transaction-search-title'
            >
              {t('Transaction_Search_results')} {`(${listCount})`}
            </Typography>
            <Grid item xs={1}>
              <Typography className={`${classes.returnItemTitleBar}`} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <span
        className={`${classes.subHeaderStyle} ${classes.returnItemTitleSubheader}`}
        data-testid='transaction-search-helper-text'
      >
        {t(`${subHeadingText}`)}
      </span>
      <div className={classes.containerSeparator}></div>
      <Grid item container alignItems='center'>
        <Grid item className={classes.filterTextContainer}>
          <span
            className={`${classes.helperTextStyle} ${classes.centerAlign} ${classes.returnItemTitleSubheader}`}
            data-testid='transaction-search-helper-text-filter'
          >
            {t('TBR_Filter_Text')}
          </span>
        </Grid>
        <Grid item className={classes.filterButtonsContainer}>
          <Grid item>
            <BaseButton
              buttonType='white'
              className={classes.filterButtonStyle}
              onClick={() => handleSetDateRange(DateRanges.yesterday)}
              data-testid={'calendar-yesterday'}
            >
              {t('DateRangeSelection_Lastday')}
            </BaseButton>
            <BaseButton
              buttonType='white'
              className={classes.filterButtonStyle}
              disabled={
                effectivePolicy?.receiptLookupPeriod
                  ? !isReceiptLookupPeriodGreaterThanAWeek(effectivePolicy?.receiptLookupPeriod)
                  : false
              }
              onClick={() => handleSetDateRange(DateRanges.lastWeek)}
              data-testid={'calendar-last-week'}
            >
              {t('Last Week')}
            </BaseButton>
            <BaseButton
              buttonType='white'
              disabled={
                effectivePolicy?.receiptLookupPeriod
                  ? !isReceiptLookupPeriodGreaterThanAMonth(effectivePolicy?.receiptLookupPeriod)
                  : false
              }
              className={classes.filterButtonStyle}
              onClick={() => handleSetDateRange(DateRanges.lastMonth)}
              data-testid={'calendar-last-month'}
            >
              {t('Last Month')}
            </BaseButton>
          </Grid>
        </Grid>
        <Grid item xs={6} className={classes.centerAlign}>
          <span
            className={`${classes.helperTextStyle} ${classes.returnItemTitleSubheader}`}
            data-testid='transaction-search-helper-text-scan'
          >
            {`-${t('ScanItemBarcodeOrText')}-`}
          </span>
          <span
            className={`${classes.helperTextStyle} ${classes.leftMargin} ${classes.returnItemTitleSubheader}`}
            data-testid='transaction-search-helper-text-scan-barcode'
          >
            {t('ScanItemBarcodeText')}
          </span>
        </Grid>
      </Grid>
      <div className={classes.containerSeparator}></div>
    </>
  );
};
